import nodule41 from "./nodule4-1";
import nodule42 from "./nodule4-2";
import nodule43 from "./nodule4-3";
import nodule44 from "./nodule4-4";
import nodule45 from "./nodule4-5";
import nodule46 from "./nodule4-6";
import nodule47 from "./nodule4-7";
import nodule48 from "./nodule4-8";
import nodule49 from "./nodule4-9";
import nodule410 from "./nodule4-10";
import nodule411 from "./nodule4-11";
import nodule412 from "./nodule4-12";
import nodule413 from "./nodule4-13";
import nodule414 from "./nodule4-14";
import nodule415 from "./nodule4-15";
import nodule416 from "./nodule4-16";
import nodule417 from "./nodule4-17";

export default [
  nodule41,
  nodule42,
  nodule43,
  nodule44,
  nodule45,
  nodule46,
  nodule47,
  nodule48,
  nodule49,
  nodule410,
  nodule411,
  nodule412,
  nodule413,
  nodule414,
  nodule415,
  nodule416,
  nodule417,
];
